import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getProductSubscriptions, ProductSubscription } from "../api/Product/ProductSubscriptionApi";
import { AppThunk } from "../app/store";

interface ProductSubscriptionState {
  subscriptions: ProductSubscription[] | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ProductSubscriptionState = {
  subscriptions: null,
  isLoading: false,
  error: null
};

const subscriptions = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    getProductSubscriptionsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    getProductSubscriptionsSuccess(state, { payload }: PayloadAction<ProductSubscription[]>) {
      state.isLoading = false;
      state.error = null;
      state.subscriptions = payload;
    },
    getProductSubscriptionsFailure(state, { payload }: PayloadAction<string>) {
      state.isLoading = false;
      state.error = payload;
    }
  }
});

export const { getProductSubscriptionsStart, getProductSubscriptionsSuccess, getProductSubscriptionsFailure } =
  subscriptions.actions;

export default subscriptions.reducer;

export const fetchProductSubscriptions = (): AppThunk => async (dispatch) => {
  try {
    dispatch(getProductSubscriptionsStart());
    const subscriptions = await getProductSubscriptions();
    dispatch(getProductSubscriptionsSuccess(subscriptions));
  } catch (err: any) {
    dispatch(getProductSubscriptionsFailure(err.toString()));
  }
};
